<template>
    <div class="report-info report-report-info">
        <!-- 1、五行能量部分 -->
        <div class="report-info-eight-word-content">
            <div class="report-info-ewc-content">
                <!-- <p class="report-info-ewc-title"><span class="title">五行能量大小分布</span></p> -->
                <div v-if="reportStrongData && reportStrongData.wxData" class="report-info-ewc-data-content">
                    <report-energy-item :itemData="reportStrongData.wxData.gold"></report-energy-item>
                    <report-energy-item :itemData="reportStrongData.wxData.wood"></report-energy-item>
                    <report-energy-item :itemData="reportStrongData.wxData.water"></report-energy-item>
                    <report-energy-item :itemData="reportStrongData.wxData.fire"></report-energy-item>
                    <report-energy-item :itemData="reportStrongData.wxData.soil"></report-energy-item>
                </div>
            </div>
            <div class="report-info-ewc-content">
                <div class="report-info-ewc-top-title">命主八字五行能量分布如上，更多喜忌如下：</div>
                <div class="report-info-ewc-title clearfix"  v-if="reportStrongData && reportStrongData.goodWx">
                    <div class="ewc-title-box"><span class="title">五行喜忌：</span></div>
                    <div class="title-content">
                        喜<span v-for="goodData in reportStrongData.goodWx" :class="'word-'+goodData.wxEn">{{ goodData.wxText }}</span>，忌<span v-for="badData in reportStrongData.badWx" :class="'word-'+badData.wxEn">{{ badData.wxText }}</span>
                    </div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.goodFw">
                    <div class="ewc-title-box"><span class="title">有利方向：</span></div>
                    <div class="title-content">{{ reportStrongData.goodFw.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.badFw">
                    <div class="ewc-title-box"><span class="title">不利方向：</span></div>
                    <div class="title-content">{{ reportStrongData.badFw.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.goodColour">
                    <div class="ewc-title-box"><span class="title">喜用颜色：</span></div>
                    <div class="title-content">{{ reportStrongData.goodColour.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.badColour">
                    <div class="ewc-title-box"><span class="title">忌用颜色：</span></div>
                    <div class="title-content">{{ reportStrongData.badColour.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.goodAni">
                    <div class="ewc-title-box"><span class="title">喜用生肖：</span></div>
                    <div class="title-content">{{ reportStrongData.goodAni.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title" v-if="reportStrongData && reportStrongData.badAni">
                    <div class="ewc-title-box"><span class="title">易冲生肖：</span></div>
                    <div class="title-content">{{ reportStrongData.badAni.join('、') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReportEnergyItem from '../common/ReportEnergyItem.vue';
export default {
    name: 'ReportInfo',
    components: { ReportEnergyItem },
    computed: {
        reportData() {
            return this.$store.state.report.reportData;
        },
        reportStrongData() {
            return this.$store.state.report.reportStrongData;
        },
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>
